
export default props => {
    let direction = "";

    if (props.x > 50) direction = "on-right";
    
    const jsx = (<div className="">
        <style jsx>{`

.label-container{
    position: absolute;
    top: calc(${props.y}% - 15px);
    right: calc(${100 - props.x}% - 15px);
    height: 30px;
    line-height: 30px;
}


.label-container.on-right{
    left: calc(${props.x}% - 15px);
    right:auto;
}

.f1, .f11{
    width: 0;
    height:0;
    border-top:solid 15px transparent;
    border-right:solid 15px #55d5ce;;
    border-bottom:solid 15px transparent;
    border-left:solid 15px transparent;
}

.f2{
    margin: 0;
    border: 0;
    padding: 0 15px;

    background-color: #55d5ce;
    color: white;

    height: 30px;
    line-height: 30px;
    vertical-align: top;

    font-size: 12px;
}

.f3, .f31{
    background-color: #55d5ce;;
    vertical-align: top;
    margin: 0;
    border: 0;
    padding: 0;
    height: 30px;
    line-height: 30px;
}

.f3 img, .f31 img{
    padding: 3px;
}

.f11{
    display:inline-block;
    width: 0;
    height:0;
    border-top:solid 15px transparent;
    border-right:solid 15px transparent;
    border-bottom:solid 15px transparent;
    border-left:solid 15px #55d5ce;
}

.f11, .f3{
    display:inline-block;
}

.f1, .f31{
    display:none;
}


.on-right .f1, .on-right .f31{
    display:inline-block;
}

.on-right .f11, .on-right .f3{
    display:none;
}



.on-right .next{
    transform: scaleX(-1);
}
`}</style>

        <div className={"label-container " + direction} style={{ display: props.d }}>
            <div className="dib f1" />
            <div className="dib f3">
                <img className="next" src="/assets/images/next.svg" />
                <img className="close" src="/assets/images/x_white.svg" />
            </div>
            <div className="dib f2">
                {(props.url ?
                    <a href={props.url} target="_blank">{props.trademark}</a> :
                    props.trademark
                )}
            </div>
            <div className="dib f11" />
            <div className="dib f31">
                <img className="close" src="/assets/images/x_white.svg" />
                <img className="next" src="/assets/images/next.svg" />
            </div>
        </div>


    </div>);
    return jsx;
}